import contour from "../Assets/contourbg.jpg"
import ImageText from "../Utils/ImageText"
import Tick from "../Assets/Tick.png"
import Homeimg from "../Assets/Home.png"
const Intro=({mycontactref})=>
{
    let text=["Streamlined and Effortless Solution for Property Owners",
        "Unlock the Potential of Your maximum Rental Earnings with Ease",
        "Wide exposure and marketing for your property across multiple channels",
        "Seamless Booking and Reservation Management through Robust Tech"
    ]
    return(
        <div style={{height:"100%",backgroundImage:`url(${contour})`,backgroundRepeat:"no-repeat",backgroundSize:"cover"}} className="sm:px-[16px] sm:pb-[66px] lg:pl-[160px] lg:py-[0px] lg:pr-[70px] text-black">
            <div id="mainimage" className="bg-white sm:w-full lg:w-[55%] lg:py-[30px] sm:p-[20px] lg:px-[60px]">
                <p style={{fontFamily:"Playfair Display, Sans-serif"}} className="lg:hidden sm:block sm:text-[24px] sm:leading-[42px] sm:font-[600]">Unveil End-to-End Vacation Rental Management Services with BRIK itt</p>
                <p style={{fontFamily:"Playfair Display, Sans-serif"}} className="sm:hidden lg:block lg:text-[40px] lg:font-[600] lg:leading-[65px]">Unveil End-to-End Vacation Rental Management Services with BRIK itt</p>
                {/* <p style={{fontFamily:"Playfair Display, Sans-serif"}} className="sm:hidden lg:block lg:text-[44px] lg:font-[600] lg:leading-[90px]"></p> */}
                <div className="lg:flex flex-row items-center gap-x-[50px] justify-between items-center">
                    <div>
                            <div className="lg:mb-[50px] sm:mb-[30px]">
                            {
                                text?.map((e,i)=>
                                {
                                    return <ImageText className="sm:text-[13px] lg:text-[20px] font-[400] leading-[27px] text-black sm:my-[27px] lg:my-[30px]" key={i} url={Tick} line={e} />
                                })
                            }
                            </div>
                            <div className="w-full sm1:block sm:flex justify-center">
                                <button id="activeeffect" onClick={()=>mycontactref.current.scrollIntoView({ behavior: 'smooth'})} style={{fontFamily:"Inter"}} className="hover:bg-[#a77202] text-[16px] px-[35px] py-[15px] text-white bg-[#D08E02] font-[500] leading-[20px] cursor-pointer">GET A CALLBACK</button>
                            </div>
                    </div>
                    {/* <div>
                        <img className="sm:hidden lg:block w-full mt-[40px]" src={Homeimg} />
                    </div> */}
                
                </div>
            </div>
        </div>
    )
}
export default Intro